<div class="template-error">
  <ids-mobile-header [headingElement]="bgBaseH1" class="ids-theme-change">
    <h1 #bgBaseH1 class="cdk-visually-hidden" aria-hidden="true"></h1>
    <button #btnHeader idsMobileHeaderControls [attr.aria-label]="labelBtnHeader" (click)="onCloseBtnClick()">
      <ids-icon>fechar_outline</ids-icon>
    </button>
  </ids-mobile-header>

  <div class="template-error__content">
    <div class="ids-d-flex ids-justify-content-center ids-py-4">
      <img
        [attr.src]="content.img"
        alt="icon"
        aria-hidden="true"
      />
    </div>
    <h1 class="ids-title -small -bold template-error__title">
      {{ content.title }}
    </h1>
    <p class="ids-body-text template-error__description">
      {{ content.descrition }}
    </p>
  </div>

  <div class="template-error__area-button">
    <button idsMainButton full="true" variant="secondary" (click)="onCloseBtnClick()">Sair do App íon</button>

    <button idsMainButton full="true" class="mrg-top" [ngClass]="{'loading-custom': loadingButton}"
    [attr.aria-label]="loadingButton ? 'Carregando página' : 'Tentar novamente'" 
    (click)="onTryAgain()"
    *ngIf="showBtnTryAgain">
      <span *ngIf="!loadingButton">Tentar novamente</span>
      <div *ngIf="loadingButton" aria-hidden="true" class="ids-button__loader">
        <ids-loading size="S" contrast="onBrand"></ids-loading>
      </div>
    </button>
  </div>
</div>

<div class="sr-only" *ngIf="alertVoiceOver" aria-live="assertive">Carregando página</div>